import {_formatDateTimeZone} from "./utility";

export default function getFormattedDateRange(dateFrom, dateTo, currentDateText) {
    const format = 'DD MMM YYYY';
    let formattedFromDate = _formatDateTimeZone(dateFrom, format);
    let formattedToDate = _formatDateTimeZone(dateTo, format);

    return [
        formattedFromDate,
        dateTo ? formattedToDate : currentDateText,
    ]
        .filter(Boolean)
        .join(' - ');
}
